import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {SortType} from "../../../../commons/types/sort.type";

export interface RoutesPanelSortingDialogData {
  sortBy: string;
  sortType: SortType;
  options?: string[];
}

require('./routes-panel-sorting-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-routes-panel-sorting-dialog',
  templateUrl: './routes-panel-sorting-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutesPanelSortingDialogComponent implements OnInit {

  @Output() onSortTypeChange = new EventEmitter<{sortBy: string, sortType: SortType}>();

  public sortBy: string;
  public sortType: SortType;
  public options: string[] = [];

  constructor(@Inject(PANEL_DATA) public data: RoutesPanelSortingDialogData) {
  }

  ngOnInit() {
    this.sortBy = this.data.sortBy;
    this.sortType = this.data.sortType;
    this.options = this.data.options || [];
  }

  onToggleSortTypeChange(sortBy: string, sortType) {
    this.sortBy = sortBy;
    this.sortType = sortType;
    this.onSortTypeChange.emit({sortBy: sortBy, sortType: sortType});
  }

  trackByOption(index: number, option: string): string {
    return option;
  }

}
